// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact{
    margin-top: 80px;
    margin-bottom: 60px;
}
.form-group label {
    font-size: 16px;
    font-weight: 800;
    color: #0b2238;
}
.form-control {
    background-color: #f7f8fa;
    border-color: transparent;
}
.form-control:focus {
    background-color: #ffffff;
    box-shadow: none;
}
.form-group input, .form-group select  {
    height: 55px;
    padding-left: 1.25rem;
    color: #0b2238 !important;
    font-size: 16px;
    border-radius: 8px;
    font-weight: 500;
    border-color: #215d88b0;
    transition: 0.3s !important;
}
.btn-sub{
    border-radius: 10px;
    border: 1px solid #0ec6fb;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    padding: 10px 20px;
    background: #0ec6fb 0% 0% no-repeat padding-box;
}
.ambassador-name {
    background: #05050547;
    width: 100%;
    bottom: 0;
}
.background-color{
    /* background-color: #c7e8ec!important; */
    background-color: #e4e4e4!important;
}
.modal-opacity{
    background-color:rgb(200 190 190 / 65%);
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
}
.heads
     {
        line-height: 0.6;
    }
    .sub-head {
        line-height: 0.9;
    }
@media screen and (max-width:600px){
    .scroll-right{
        right:15px;
        top: 50%;
        z-index: 1;
        font-size: 16px;
    }
    .right-button{
        border-radius:50%;
    }
    .scroll-left{
        left:15px;
        top: 50%;
        z-index: 1;
        font-size: 16px;
    }
    .left-button{
        border-radius:50%;
    }
    .heads
     {
        line-height: 0.6;
        font-size: 32px;
    }
    .sub-head {
        line-height: 0.8;
    }
    .contact {
        margin-top: 65px;
    }
    .xs-register-scroll {
        white-space: inherit;
        overflow-x: auto;
        overflow-y: hidden;
        flex-wrap: nowrap;
        -ms-overflow-style: none;
        scrollbar-width: none;
        -webkit-scrollbar-width: none;
        padding-right: 5rem;
        padding-top: 2rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/community-detail/community-detail.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,2BAA2B;AAC/B;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,+CAA+C;AACnD;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,SAAS;AACb;AACA;IACI,yCAAyC;IACzC,mCAAmC;AACvC;AACA;IACI,uCAAuC;IACvC,kCAA0B;YAA1B,0BAA0B;AAC9B;AACA;;QAEQ,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;AACJ;IACI;QACI,UAAU;QACV,QAAQ;QACR,UAAU;QACV,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,SAAS;QACT,QAAQ;QACR,UAAU;QACV,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;IACA;;QAEI,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,oBAAoB;QACpB,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB;QACjB,wBAAwB;QACxB,qBAAqB;QACrB,6BAA6B;QAC7B,mBAAmB;QACnB,iBAAiB;IACrB;AACJ","sourcesContent":[".contact{\n    margin-top: 80px;\n    margin-bottom: 60px;\n}\n.form-group label {\n    font-size: 16px;\n    font-weight: 800;\n    color: #0b2238;\n}\n.form-control {\n    background-color: #f7f8fa;\n    border-color: transparent;\n}\n.form-control:focus {\n    background-color: #ffffff;\n    box-shadow: none;\n}\n.form-group input, .form-group select  {\n    height: 55px;\n    padding-left: 1.25rem;\n    color: #0b2238 !important;\n    font-size: 16px;\n    border-radius: 8px;\n    font-weight: 500;\n    border-color: #215d88b0;\n    transition: 0.3s !important;\n}\n.btn-sub{\n    border-radius: 10px;\n    border: 1px solid #0ec6fb;\n    color: #fff;\n    font-size: 18px;\n    font-weight: bold;\n    padding: 10px 20px;\n    background: #0ec6fb 0% 0% no-repeat padding-box;\n}\n.ambassador-name {\n    background: #05050547;\n    width: 100%;\n    bottom: 0;\n}\n.background-color{\n    /* background-color: #c7e8ec!important; */\n    background-color: #e4e4e4!important;\n}\n.modal-opacity{\n    background-color:rgb(200 190 190 / 65%);\n    backdrop-filter: blur(5px);\n}\n.heads\n     {\n        line-height: 0.6;\n    }\n    .sub-head {\n        line-height: 0.9;\n    }\n@media screen and (max-width:600px){\n    .scroll-right{\n        right:15px;\n        top: 50%;\n        z-index: 1;\n        font-size: 16px;\n    }\n    .right-button{\n        border-radius:50%;\n    }\n    .scroll-left{\n        left:15px;\n        top: 50%;\n        z-index: 1;\n        font-size: 16px;\n    }\n    .left-button{\n        border-radius:50%;\n    }\n    .heads\n     {\n        line-height: 0.6;\n        font-size: 32px;\n    }\n    .sub-head {\n        line-height: 0.8;\n    }\n    .contact {\n        margin-top: 65px;\n    }\n    .xs-register-scroll {\n        white-space: inherit;\n        overflow-x: auto;\n        overflow-y: hidden;\n        flex-wrap: nowrap;\n        -ms-overflow-style: none;\n        scrollbar-width: none;\n        -webkit-scrollbar-width: none;\n        padding-right: 5rem;\n        padding-top: 2rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
